import { Report } from './report.model';

export class ReportFolder {
    Description: string;
    Id: number;
    Name: string;
    Reports: Report[];
    ReportInFolder: boolean;
    IsDetailRowExpanded: boolean;
    Order: number;
}